/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import MarkdownEntry from "../../datatypeComponents/MarkdownEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import CodeableReferenceEntry from "../../datatypeComponents/CodeableReferenceEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import { evidenceVariableDefinitionConceptSystemChoices, evidenceVariableDotHandlingValueSet } from "../EvidenceVariableResourceDisplay";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import NarrativeEntry from "../../datatypeComponents/NarrativeEntry";
import generateNarrativeForEvidenceVariableResource from "../generateNarrativeFunctions/generateNarrativeForEvidenceVariableResource";
import CodeableConceptEntry from "../../datatypeComponents/CodeableConceptEntry";
import convertEvidenceVariableHandlingToCodeableConcept from "../resourceDisplayCommonFunctions/convertEvidenceVariableHandlingToCodeableConcept";

const EvidenceVariableResourceEdit = ({ foi }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({
        text: resourceJson.text,
        title: resourceJson.title,
        shortTitle: resourceJson.shortTitle,
        name: resourceJson.name,
        description: resourceJson.description,
        definition: resourceJson.definition,
        definitionModifier: resourceJson.definitionModifier,
        handling: convertEvidenceVariableHandlingToCodeableConcept(resourceJson.handling),
        category: resourceJson.category,
        relatesTo: resourceJson.relatesTo
    });

    useEffect(() => {
        if (resourceJson) {
            updateNarrativeElement(editResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.text]);

    useEffect(() => {
        if (editResourceState) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.shortTitle || editResourceState.name;
            if (editResourceState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.title)) {
                console.log("resourceUpdate for EvidenceVariable.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "title",
                    previousInitialValue,
                    editResourceState.title);
            }
        }
    }, [editResourceState.title]);

    useEffect(() => {
        if (editResourceState) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.shortTitle;
            previousFinalValue = newResourceDetail.revisedResourceJson.shortTitle;
            newResourceDetail.revisedResourceJson.shortTitle = editResourceState.shortTitle;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.shortTitle || editResourceState.name;
            if (editResourceState.shortTitle !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.shortTitle)) {
                console.log("resourceUpdate for EvidenceVariable.shortTitle");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "shortTitle",
                    previousInitialValue,
                    editResourceState.shortTitle);
            }
        }
    }, [editResourceState.shortTitle]);

    useEffect(() => {
        if (editResourceState) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.shortTitle || editResourceState.name;
            if (editResourceState.name !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.name)) {
                console.log("resourceUpdate for EvidenceVariable.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "name",
                    previousInitialValue,
                    editResourceState.name);
            }
        }
    }, [editResourceState.name]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "description", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "definition", "CodeableReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.definition]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "definitionModifier", "ArrayOfEvidenceVariableDefinitionModifier", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.definitionModifier]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "handling", "CodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.handling]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "category", "ArrayOfEvidenceVariableCategory", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.category]);

    useEffect(() => {
        if (editResourceState) {
            updateElement(editResourceState, "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [editResourceState.relatesTo]);

    return <div style={{ marginLeft: "24px" }}>
        {editResourceState && <>
            <StringEntry elementName='title'
                fieldLabel={'Title (Human-friendly Label for Variable Name)'}
                startingValue={editResourceState.title || ""}
                required={(resourceJson?.description || resourceJson?.name || resourceJson?.definition || resourceJson?.handling || resourceJson?.category)}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='shortTitle'
                fieldLabel={'Short Title (for Variable Name)'}
                startingValue={editResourceState.shortTitle || ""}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name'
                fieldLabel={'Name (Machine Label for Variable Name)'}
                startingValue={editResourceState.name || ""}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Description'}
                startingValue={editResourceState.description || ""}
                setResourceState={setEditResourceState} />
            <CodeableReferenceEntry elementName='definition'
                fieldLabel='Variable Definition'
                referencedResourceTypes={['Group']}
                enableCreation={true} systemChoices={evidenceVariableDefinitionConceptSystemChoices}
                systemChoicesOpen={true}
                startingValue={editResourceState.definition} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='EvidenceVariableDefinitionModifier' elementName='definitionModifier'
                fieldLabel='Definition Modifier' startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                startingValue={editResourceState.definitionModifier} setResourceState={setEditResourceState} />
            <CodeableConceptEntry elementName='handling' fieldLabel='Handling'
                startingValue={editResourceState.handling} setResourceState={setEditResourceState}
                codeableConceptLevelValueSet={evidenceVariableDotHandlingValueSet} />
            <ArrayEntry datatype='EvidenceVariableCategory' elementName='category'
                fieldLabel='Category' startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                startingValue={editResourceState.category}
                setResourceState={setEditResourceState} />
            <p>Narrative Summary</p>
            <div style={{ marginLeft: "24px" }}>
                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                    generatedNarrative={generateNarrativeForEvidenceVariableResource(resourceJson)} startCollapsed
                    startingValue={editResourceState.text} setResourceState={setEditResourceState} />
            </div>
            <ArrayEntry datatype='RelatesTo' elementName='relatesTo'
                fieldLabel='Related Item' startEmptyArrayClosed={true} deletable={true}
                deletableArray={true} startCollapsed={true}
                startingValue={editResourceState.relatesTo}
                setResourceState={setEditResourceState} />
        </>}
    </div>
}

export default EvidenceVariableResourceEdit;